"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractPropsAsTests = void 0;
var lodash_1 = require("lodash");
var propToPropPair_1 = require("./propToPropPair");
var extractPropsAsTests = function (obj) { return function () {
    var props = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        props[_i] = arguments[_i];
    }
    return lodash_1.flow([
        propToPropPair_1.propToPropPair,
        lodash_1.partialRight(lodash_1.map, function (propPair) { return (__assign(__assign({}, propPair), { actualValue: lodash_1.get(obj, propPair.propName) })); })
    ]).apply(void 0, props);
}; };
exports.extractPropsAsTests = extractPropsAsTests;
//# sourceMappingURL=extractPropsAsTests.js.map